document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll(".expandable-image");
  const modal = document.getElementById("imageModal");
  const modalImg = document.getElementById("modalImage");
  const overlay = document.getElementById("modalOverlay");
  const closeBtn = document.querySelector(".close");

  images.forEach(image => {
    image.addEventListener("click", function () {
      modal.style.display = "block";
      overlay.style.display = "block"; // Show overlay
      modalImg.src = this.src;
    });
  });

  function closeModal() {
    modal.style.display = "none";
    overlay.style.display = "none"; // Hide overlay
  }

  closeBtn.addEventListener("click", closeModal);
  overlay.addEventListener("click", closeModal); // Clicking backdrop closes modal
});
